var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"depressed":"","color":"primary","loading":_vm.isLoading,"width":_vm.width,"disabled":_vm.disabled || _vm.isLoading,"data-cy":_vm.dataCy},on:{"click":_setup.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }